import { BoardMediaImageErrorRender } from "./board-media-image-error-render";
import { BoardMediaImageError } from "./board-media-image-error-utils";
import { BoardMediaImageErrorListener } from "./board-media-image-error-listener";

class BoardMediaImageErrorSetup {
    public static init(): void {
        const root = document.documentElement;
        if (!(root instanceof HTMLElement)) return;
        if (root.dataset.boardMediaImageErrorInit === "1") return;
        root.dataset.boardMediaImageErrorInit = "1";

        const render = new BoardMediaImageErrorRender();
        const error = new BoardMediaImageError({ render });
        const listener = new BoardMediaImageErrorListener({ error });
        listener.register();
        error.replaceAlreadyBrokenImages(document);
    }
}

export { BoardMediaImageErrorSetup };
